import { notification, PopOver, Skeleton, Text } from "components/common"
import { InfoBlock } from "components/custom"
import { DATE_FORMAT, TIME_FORMAT } from "constants"
import { useLazyGetEditedTaskDetailsQuery } from "features/tasks/api"
import { t } from "i18next"
import { localisedValue } from "utils"
import { dateTimeFunction } from "utils/date"

const EditedTaskTooltip = ({ taskId, from, textToShow }) => {
  const [getEditedTaskDetails, { data: editedTaskData, isFetching: editedTaskDataFetching }] =
    useLazyGetEditedTaskDetailsQuery()

  const data = [
    editedTaskData?.[0]?.LogCreatedBy?.id !== -1 && {
      label: t("Updated By"),
      data: localisedValue({ object: editedTaskData?.[0]?.LogCreatedBy, key: "name" }),
    },
    {
      label: t("Updated At"),
      data: `${dateTimeFunction({
        date: editedTaskData?.[0]?.logCreatedAt || editedTaskData?.[0]?.logDate,
        format: DATE_FORMAT,
      })}
          ${dateTimeFunction({
            date: editedTaskData?.[0]?.logCreatedAt || editedTaskData?.[0]?.logDate,
            format: TIME_FORMAT,
          })}`,
    },
  ]

  return (
    <PopOver
      trigger="click"
      content={
        editedTaskDataFetching ? (
          <div style={{ display: "flex", gap: 10, flexDirection: "column" }}>
            <Skeleton height={30} width={235} />
            <Skeleton height={30} width={235} />
          </div>
        ) : (
          <InfoBlock size="small" data={data} />
        )
      }
      className="pointer"
    >
      <Text
        className="fs12"
        type="secondaryLight"
        onClick={event => {
          event.stopPropagation()
          getEditedTaskDetails({ taskId: taskId, detailsType: from }, true)
            .unwrap()
            .then(response => {})
            .catch(error => {
              notification.error({ message: error.message })
            })
        }}
      >
        {textToShow}
      </Text>
    </PopOver>
  )
}

export default EditedTaskTooltip
